
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10 1.667A5.83 5.83 0 004.167 7.5C4.167 11.875 10 18.333 10 18.333s5.834-6.458 5.834-10.833A5.83 5.83 0 0010 1.667zM5.834 7.5C5.834 5.2 7.7 3.333 10 3.333c2.3 0 4.167 1.867 4.167 4.167 0 2.4-2.4 5.992-4.167 8.233C8.267 13.508 5.834 9.875 5.834 7.5zm2.083 0a2.083 2.083 0 114.167 0 2.083 2.083 0 01-4.167 0z","fill":"#9AA0B5"}})])
          )
        }
      }
    